import { Vfsfileprocess as VfsFileList } from './vfsfileprocess'

export const vfsfileprocess = {
   list: VfsFileList,
}
